module.exports = __webpack_public_path__ + "static/img/6.3ef319c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Text/6.png
// module id = 356
// module chunks = 0